import styled from 'styled-components';
import { StockModelListStyled } from '../StockModelListStyled';
import { rem } from 'polished';

export const StockModelListStyledAP = styled(StockModelListStyled)`
    .showMore--btn {
        border: 1px solid ${({ theme }) => theme.colors.primary};
        background-color: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.black};
    }

    .grid {
        display: flex;
        flex-wrap: wrap;
    }
`;
